<!-- @format -->
<template>
  <div class="template-questes-edit">
    <el-container class="main-container">
      <el-header style="padding: 0">
        <div class="header-bar">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/uxm/templateProject' }">模板项目管理</el-breadcrumb-item>
            <el-breadcrumb-item>{{ projectName }}</el-breadcrumb-item>
            <el-breadcrumb-item>编辑问卷</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-header>
      <el-container class="content-container">
        <el-main class="el-main">
          <div class="questes-edit-wrapper">
            <iframe
              :src="editUrl"
              frameborder="0"
              style="width: 100%; height: calc(100vh - 100px);"
              @load="handleIframeLoad"
            ></iframe>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'TemplateQuestesEdit',
  data() {
    return {
      templateQuestesId: null,
      templateProjectId: null,
      projectName: '',
      editUrl: ''
    }
  },
  created() {
    // 【重要】确保ID正确转换为字符串，避免BigNumber精度丢失
    this.templateQuestesId = this.$route.params.questesId ? String(this.$route.params.questesId) : null
    this.templateProjectId = this.$route.query.templateProjectId ? String(this.$route.query.templateProjectId) : null
    this.projectName = decodeURIComponent(this.$route.query.projectName || '')
    
    if (!this.templateQuestesId) {
      console.error('模板问卷ID不存在，无法编辑')
      this.$message.error('模板问卷ID不存在，无法编辑')
      return
    }
    
    // 获取管理端token，传递给用户端页面（实现免登录）
    const adminToken = localStorage.getItem('token') || ''
    
    const userFrontendBaseUrl = 'http://localhost:8080'
    // 问卷编辑页面URL：需要传递edit参数和surveyId参数
    // 注意：surveyPreview页面使用surveyId参数，而不是id参数
    const tokenParam = adminToken ? `&adminToken=${encodeURIComponent(adminToken)}` : ''
    // 【重要】确保ID以字符串形式传递，避免精度丢失
    this.editUrl = `${userFrontendBaseUrl}/survey_preview?edit=1&surveyId=${this.templateQuestesId}&projectId=${this.templateProjectId}&isTemplate=true${tokenParam}`
    
    console.log('构建编辑页面URL:', {
      templateQuestesId: this.templateQuestesId,
      templateProjectId: this.templateProjectId,
      projectName: this.projectName,
      editUrl: this.editUrl
    })
  },
  methods: {
    handleIframeLoad() {
      console.log('问卷编辑页面加载完成')
    }
  }
}
</script>

<style scoped>
.template-questes-edit {
  width: 100%;
  height: 100vh;
}

.main-container {
  height: 100%;
}

.header-bar {
  padding: 15px 20px;
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
}

.content-container {
  height: calc(100% - 60px);
}

.el-main {
  padding: 0;
  height: 100%;
}

.questes-edit-wrapper {
  width: 100%;
  height: 100%;
}
</style>

